/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Actieverzoek */
export interface Actieverzoek {
  /** Id */
  id: string;
  /** Actieverzoekid */
  actieverzoekId: string;
  /**
   * Creatiedatumtijd
   * @format date-time
   */
  creatieDatumTijd: string;
  /**
   * Documenten
   * @default []
   */
  documenten?: Document[];
  /** Melding */
  melding: string | null;
  /** Omschrijving */
  omschrijving: string | null;
  /** Ontvanger */
  ontvanger: string | null;
  /** Ontvangernaam */
  ontvangerNaam: string | null;
  /** Productid */
  productId: string | null;
  /** Samenwerkingid */
  samenwerkingId: string | null;
  /** Status */
  status: string | null;
  /** Titel */
  titel: string | null;
  /** Zender */
  zender: string | null;
  /** Zendernaam */
  zenderNaam: string | null;
  /** Zaak Nummer */
  zaak_nummer?: number | null;
}

/** ActionType */
export enum ActionType {
  CreateCase = "create_case",
  AddNote = "add_note",
  SyncDocument = "sync_document",
  SendMessage = "send_message",
  SendToUrl = "send_to_url",
  Archive = "archive",
}

/**
 * Activiteit
 * Een activiteit waarvoor het verzoek is ingediend.
 */
export interface Activiteit {
  /**
   * Id
   * De functioneleStructuurReferentie van de activiteit.
   */
  id: string;
  /**
   * Urn
   * De URN (imow-id) van de activiteit.
   */
  urn: string;
  /**
   * Naam
   * De naam van de activiteit.
   */
  naam: string;
  /**
   * Subactiviteit
   * Sub-activiteiten, indien van toepassing.
   */
  subactiviteit?: SubActiviteit[] | null;
}

/** AllowedActionTypesOut */
export interface AllowedActionTypesOut {
  /** Action Types */
  action_types: ActionType[];
}

/** AuditLogOut */
export interface AuditLogOut {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Organization Id */
  organization_id: number;
  /** Samenwerking Id */
  samenwerking_id: string;
  /** Actor */
  actor: string;
  /** Description */
  description: string;
  /** Notificatie Id */
  notificatie_id?: string | null;
  /**
   * Created
   * @format date-time
   */
  created: string;
  /**
   * Lastmodified
   * @format date-time
   */
  lastModified: string;
}

/** Bericht */
export interface Bericht {
  /** Id */
  id: string;
  /** Berichtid */
  berichtId: string;
  /** Actieverzoekid */
  actieverzoekId: string | null;
  /** Samenwerkingid */
  samenwerkingId: string | null;
  /** Inhoud */
  inhoud: string | null;
  /** Creatiedatumtijd */
  creatieDatumTijd: string | null;
  /** Zender */
  zender: string | null;
  /** Zendernaam */
  zenderNaam: string | null;
  /** Ontvanger */
  ontvanger: string | null;
  /** Ontvangernaam */
  ontvangerNaam: string | null;
}

/**
 * BevoegdGezagInfo
 * Informatie over een organisatie (bevoegd gezag of behandeldienst).
 */
export interface BevoegdGezagInfo {
  /**
   * Organisatieidentificatienummer
   * Het 20-cijferig Organisatie Identificatie Nummer (OIN).
   * @example "00000099130854102021"
   */
  organisatieIdentificatieNummer: string;
  /**
   * Naam
   * De naam van de organisatie.
   * @example "gemeente TST_06"
   */
  naam: string;
}

/** Body_upload_document_api_v1_documenten__samenwerkingId__post */
export interface BodyUploadDocumentApiV1DocumentenSamenwerkingIdPost {
  /**
   * File
   * @format binary
   */
  file: File;
}

/** ConfigurationCreate */
export interface ConfigurationCreate {
  /** Welcome message */
  welcomeMessage?: string | null;
}

/** ConfigurationOut */
export interface ConfigurationOut {
  /**
   * Unique identifier
   * @format uuid
   */
  id: string;
  /** Welcome message */
  welcomeMessage?: string | null;
}

/** ConfigurationUpdate */
export interface ConfigurationUpdate {
  /** Welcome message */
  welcomeMessage?: string | null;
}

/** CreateActieverzoek */
export interface CreateActieverzoek {
  /** Documenten */
  documenten?: string[] | null;
  /** Omschrijving */
  omschrijving: string;
  /** Ontvanger */
  ontvanger: string;
  /** Productid */
  productId?: string | null;
  /** Titel */
  titel: string;
}

/** CreateBericht */
export interface CreateBericht {
  /** Bericht */
  bericht: string;
}

/** CreateDeelnemer */
export interface CreateDeelnemer {
  /**
   * Partnerid
   * De identificatie van de organisatie.
   */
  partnerId: string;
  /**
   * Privilege
   * Privilegetype: VT of BT.
   */
  privilege: string;
}

/** Deelnemer */
export interface Deelnemer {
  /**
   * Id
   * De identificatie van de deelnemer.
   */
  id: string;
  /** Details van de ketenpartner. */
  organisatie: AppApiSamenwerkingenDeelnemersSchemasOrganisatie;
  /**
   * Privilege
   * Privilegetype: VT, BT of INITIATOR.
   */
  privilege: string;
}

/** Document */
export interface Document {
  /**
   * Id
   * De unieke identifier van het document.
   */
  id: string;
  /**
   * Documentid
   * De identifier van het document.
   */
  documentId: string;
  /**
   * Bestandsnaam
   * De bestandsnaam van het document.
   */
  bestandsNaam: string;
  /**
   * Documentomschrijving
   * Een tekstuele beschrijving van het document.
   */
  documentOmschrijving?: string | null;
  /**
   * Formaat
   * Het MIME-type van het document.
   */
  formaat?: string | null;
  /**
   * Kenmerksysteem
   * Het kenmerk van een extern systeem.
   */
  kenmerkSysteem?: string | null;
  /**
   * Nummerbinnensysteem
   * Het identificerend nummer binnen een extern systeem.
   */
  nummerBinnenSysteem?: string | null;
  /**
   * Vertrouwelijkheidsaanduiding
   * De vertrouwelijkheidsaanduiding van het document (SV, RV).
   */
  vertrouwelijkheidsAanduiding?: string | null;
  /**
   * Taal
   * De taal waarin het document is opgesteld.
   */
  taal?: string | null;
  /**
   * Documenthash
   * De documenthash.
   */
  documentHash?: string | null;
  /**
   * Creatiedatumtijd
   * De datum en tijd waarop het document is toegevoegd.
   */
  creatieDatumTijd?: string | null;
  /**
   * Aangemaaktdoor
   * OrganisatieId van de gebruiker die het document heeft toegevoegd.
   */
  aangemaaktDoor?: string | null;
  /**
   * Aangemaaktdoornaam
   * Naam van de gebruiker die het document heeft toegevoegd.
   */
  aangemaaktDoorNaam?: string | null;
  /**
   * Laatstaangepastdatumtijd
   * De datum en tijd van de laatste wijziging van het document.
   */
  laatstAangepastDatumTijd?: string | null;
  /**
   * Laatstaangepastdoor
   * OrganisatieId van de gebruiker die het document voor het laatst heeft aangepast.
   */
  laatstAangepastDoor?: string | null;
  /**
   * Laatstaangepastdoornaam
   * Naam van de gebruiker die het document voor het laatst heeft aangepast.
   */
  laatstAangepastDoorNaam?: string | null;
}

/** DocumentDeleted */
export interface DocumentDeleted {
  /**
   * Id
   * De id van het verwijderde document.
   */
  id: string;
}

/** DocumentDownload */
export interface DocumentDownload {
  /**
   * Id
   * De id van het document.
   */
  id: string;
  /**
   * Filename
   * Bestandsnaam van het document.
   */
  filename: string;
  /**
   * Mimetype
   * MIME-type van het document.
   */
  mimeType: string;
  /**
   * Data
   * Base64-gecodeerde bestandsinhoud.
   */
  data: string;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** Notificatie */
export interface Notificatie {
  /**
   * Id
   * De unieke identifier van de notificatie.
   */
  id: string;
  /**
   * Notificatieid
   * De identifier van de notificatie.
   */
  notificatieId: string;
  /**
   * Notificatietitel
   * De titel van de notificatie.
   */
  notificatieTitel: string;
  /**
   * Notificatietekst
   * De tekst van de notificatie.
   */
  notificatieTekst: string;
  /**
   * Deelnemer
   * De organisatieId van de gebruiker die deze notificatie ontvangt.
   */
  deelnemer: string;
  /**
   * Deelnemernaam
   * De naam van de gebruiker die deze notificatie ontvangt.
   */
  deelnemerNaam: string;
  /**
   * Samenwerkingid
   * De identificatie van de samenwerking.
   */
  samenwerkingId: string;
  /** Het type van de notificatie. */
  notificatieType: NotificatieType;
  /**
   * Eventinitiator
   * De organisatieId van de initiator van het event.
   */
  eventInitiator?: string | null;
  /**
   * Eventinitiatornaam
   * De naam van de initiator van het event.
   */
  eventInitiatorNaam?: string | null;
  /**
   * Eventdatumtijd
   * Het tijdstip waarop het event plaatsvond.
   * @format date-time
   */
  eventDatumTijd: string;
  /** Extra eigenschappen van de notificatie. */
  properties?: NotificatieProperties | null;
}

/** NotificatieProperties */
export interface NotificatieProperties {
  /**
   * Actieverzoekid
   * De identificatie van een actieverzoek.
   */
  actieverzoekId?: string | null;
  /**
   * Actieverzoekstatusnieuw
   * De nieuwe status van het actieverzoek.
   */
  actieverzoekStatusNieuw?: string | null;
  /**
   * Actieverzoekstatusoud
   * De oude status van het actieverzoek.
   */
  actieverzoekStatusOud?: string | null;
  /**
   * Verwijderdatumtijd
   * Het tijdstip waarop de samenwerking verloopt en verwijderd zal worden.
   */
  verwijderDatumTijd?: string | null;
}

/** NotificatieType */
export enum NotificatieType {
  BEWAARTERMIJN_VERLENGD = "BEWAARTERMIJN_VERLENGD",
  DOCUMENT_GEWIJZIGD = "DOCUMENT_GEWIJZIGD",
  DOCUMENT_TOEGEVOEGD = "DOCUMENT_TOEGEVOEGD",
  DOCUMENT_VERWIJDERD = "DOCUMENT_VERWIJDERD",
  EINDE_BEWAARTERMIJN_NADERT = "EINDE_BEWAARTERMIJN_NADERT",
  INITIATOR_GEWIJZIGD = "INITIATOR_GEWIJZIGD",
  KETENPARTNER_VERWIJDERD = "KETENPARTNER_VERWIJDERD",
  NIEUW_BERICHT = "NIEUW_BERICHT",
  PRIVILEGE_VOOR_KETENPARTNER_AANGEPAST = "PRIVILEGE_VOOR_KETENPARTNER_AANGEPAST",
  RECHTEN_OP_DOCUMENT_AANGEPAST = "RECHTEN_OP_DOCUMENT_AANGEPAST",
  SAMENWERKING_OPGEHAALD = "SAMENWERKING_OPGEHAALD",
  SAMENWERKING_GESTOPT = "SAMENWERKING_GESTOPT",
  SAMENWERKING_GEWIJZIGD = "SAMENWERKING_GEWIJZIGD",
  STATUS_ACTIEVERZOEK_GEWIJZIGD = "STATUS_ACTIEVERZOEK_GEWIJZIGD",
  UITNODIGING_KETENPARTNER = "UITNODIGING_KETENPARTNER",
  SAMENWERKING_WORDT_GESLOTEN = "SAMENWERKING_WORDT_GESLOTEN",
  VERZOEK_OPHALEN_MISLUKT = "VERZOEK_OPHALEN_MISLUKT",
  VERZOEK_OPHALEN_GESLAAGD = "VERZOEK_OPHALEN_GESLAAGD",
}

/** NotificationConfigurationCreate */
export interface NotificationConfigurationCreate {
  /** Notification type */
  notification_type: NotificatieType;
  /**
   * Action type
   * @default "create_case"
   */
  action_type?: ActionType;
  /** URL */
  url?: string | null;
  /** Casetype UUID */
  casetype_uuid?: string | null;
  /** Action configuration */
  action_config?: Record<string, string | null>;
}

/** NotificationConfigurationOut */
export interface NotificationConfigurationOut {
  /**
   * Unique identifier
   * @format uuid
   */
  id: string;
  /** Organization ID */
  organization_id: number;
  /** Notification type */
  notification_type: NotificatieType;
  /**
   * Action type
   * @default "create_case"
   */
  action_type?: ActionType;
  /** URL */
  url?: string | null;
  /** Casetype UUID */
  casetype_uuid?: string | null;
  /** Action configuration */
  action_config?: Record<string, string | null>;
}

/** NotificationConfigurationUpdate */
export interface NotificationConfigurationUpdate {
  /** Notification type */
  notification_type?: NotificatieType | null;
  /** Action type */
  action_type?: ActionType | null;
  /** URL */
  url?: string | null;
  /** Casetype UUID */
  casetype_uuid?: string | null;
  /** Action configuration */
  action_config?: Record<string, string | null> | null;
}

/** OrganizationSettingsOut */
export interface OrganizationSettingsOut {
  /** Name */
  name: string;
  /** Organization Id */
  organization_id: string;
  /** Oin Number */
  oin_number?: string | null;
  /** Organization Type */
  organization_type: string;
  /**
   * Type Config
   * @default {}
   */
  type_config?: Record<string, string | null>;
  /**
   * Type Config Schema
   * @default []
   */
  type_config_schema?: TypeConfigField[];
  /** Sync Enabled */
  sync_enabled: boolean;
}

/** OrganizationSettingsUpdate */
export interface OrganizationSettingsUpdate {
  /** Name */
  name?: string | null;
  /** Oin Number */
  oin_number?: string | null;
  /** Organization Type */
  organization_type?: string | null;
  /** Type Config */
  type_config?: Record<string, string | null> | null;
}

/** PostActieverzoekDocument */
export interface PostActieverzoekDocument {
  /** Documentid */
  documentId: string;
}

/** Samenwerking */
export interface Samenwerking {
  /** Id */
  id: string;
  /** Samenwerkingid */
  samenwerkingId: string;
  /** Titel */
  titel: string;
  /** Beschrijving */
  beschrijving?: string | null;
  /** Bronverzoek */
  bronVerzoek?: string | null;
  /** Contactpersoonemailadres */
  contactpersoonEmailadres?: string | null;
  /** Contactpersoonnaam */
  contactpersoonNaam?: string | null;
  /** Contactpersoontelefoonnummer */
  contactpersoonTelefoonnummer?: string | null;
  /** Globalelocatie */
  globaleLocatie?: string | null;
  /** Importverzoekapplicable */
  importVerzoekApplicable?: boolean | null;
  /** Kenmerksysteem */
  kenmerkSysteem?: string | null;
  /** Nummerbinnensysteem */
  nummerBinnenSysteem?: string | null;
  /** Oloverzoeknummer */
  oloVerzoeknummer?: string | null;
  /** Samenwerkdoel */
  samenwerkDoel?: string | null;
  /** Samenwerkvorm */
  samenwerkVorm?: string | null;
  /** Status */
  status?: string | null;
  /** Creatiedatumtijd */
  creatieDatumTijd?: string | null;
  /** Einddatumtijd */
  eindDatumTijd?: string | null;
  /** Laatstaangepastdatumtijd */
  laatstAangepastDatumTijd?: string | null;
  /** Laatstaangepastdoor */
  laatstAangepastDoor?: string | null;
  /** Laatstaangepastdoornaam */
  laatstAangepastDoorNaam?: string | null;
  /** Aantalactieverzoeken */
  aantalActieverzoeken?: number | null;
  /** Aantalnotificaties */
  aantalNotificaties?: number | null;
  /** Aangemaaktdoor */
  aangemaaktDoor?: string | null;
  /** Aangemaaktdoornaam */
  aangemaaktDoorNaam?: string | null;
  /** Taal */
  taal?: string | null;
  /** Oin Number */
  oin_number?: string | null;
  /** Zaak Nummer */
  zaak_nummer?: number | null;
}

/** SamenwerkingCreate */
export interface SamenwerkingCreate {
  /**
   * De naam van de samenwerking
   * De naam van de samenwerking.
   */
  titel: string;
  /** Beschrijving van de samenwerking. */
  beschrijving?: string | null;
  /**
   * Bron van het verzoek
   * Bron van het verzoek: DSO_LV of OLO.
   */
  bronVerzoek?: "DSO_LV" | "OLO" | null;
  /**
   * E-mailadres contactpersoon
   * Het e-mailadres van de contactpersoon van de ketenpartner.
   */
  contactpersoonEmailadres?: string | null;
  /**
   * Naam contactpersoon
   * De naam van de contactpersoon van de ketenpartner.
   */
  contactpersoonNaam?: string | null;
  /**
   * Telefoonnummer contactpersoon
   * Het telefoonnummer van de contactpersoon van de ketenpartner.
   */
  contactpersoonTelefoonnummer?: string | null;
  /**
   * Globale locatie
   * Globale locatie van het verzoek.
   */
  globaleLocatie?: string | null;
  /**
   * Importverzoek van toepassing
   * Geeft aan of een importverzoek van toepassing is.
   */
  importVerzoekApplicable?: boolean | null;
  /**
   * Kenmerk extern systeem
   * Het kenmerk van een extern systeem.
   */
  kenmerkSysteem?: string | null;
  /**
   * Nummer binnen systeem
   * Het nummer van de samenwerking binnen de ketenpartner.
   */
  nummerBinnenSysteem?: string | null;
  /**
   * OLO-verzoeknummer
   * Het nummer van het OLO-verzoek.
   */
  oloVerzoeknummer?: string | null;
  /**
   * Doel van de samenwerking
   * Het doel van de samenwerking.
   */
  samenwerkDoel?: string | null;
  /**
   * Type van het verzoek
   * Het type van het verzoek.
   */
  typeVerzoek?:
    | "Aanvraag vergunning"
    | "Melding"
    | "Informatie"
    | "Informatie ongewoon voorval"
    | "Aanvraag maatwerkvoorschrift"
    | "Melding gelijkwaardige maatregel"
    | "Aanvraag toestemming gelijkwaardige maatregel"
    | null;
  /**
   * Verzoeknummer
   * Verzoeknummer van de samenwerking.
   */
  verzoeknummer?: string | null;
  /**
   * Aangemaakt door
   * Het nummer van de organisatie die de samenwerking heeft aangemaakt.
   */
  aangemaaktDoor?: string | null;
  /**
   * Aangemaakt door naam
   * De naam van de organisatie die de samenwerking heeft aangemaakt.
   */
  aangemaaktDoorNaam?: string | null;
}

/** SamenwerkingUpdate */
export interface SamenwerkingUpdate {
  /**
   * De naam van de samenwerking
   * De naam van de samenwerking.
   */
  titel?: string | null;
  /** Beschrijving van de samenwerking. */
  beschrijving?: string | null;
  /**
   * Bron van het verzoek
   * Bron van het verzoek: DSO_LV of OLO.
   */
  bronVerzoek?: "DSO_LV" | "OLO" | null;
  /**
   * E-mailadres contactpersoon
   * Het e-mailadres van de contactpersoon van de ketenpartner.
   */
  contactpersoonEmailadres?: string | null;
  /**
   * Naam contactpersoon
   * De naam van de contactpersoon van de ketenpartner.
   */
  contactpersoonNaam?: string | null;
  /**
   * Telefoonnummer contactpersoon
   * Het telefoonnummer van de contactpersoon van de ketenpartner.
   */
  contactpersoonTelefoonnummer?: string | null;
  /**
   * Globale locatie
   * Globale locatie van het verzoek.
   */
  globaleLocatie?: string | null;
  /**
   * Importverzoek van toepassing
   * Geeft aan of een importverzoek van toepassing is.
   */
  importVerzoekApplicable?: boolean | null;
  /**
   * Kenmerk extern systeem
   * Het kenmerk van een extern systeem.
   */
  kenmerkSysteem?: string | null;
  /**
   * Nummer binnen systeem
   * Het nummer van de samenwerking binnen de ketenpartner.
   */
  nummerBinnenSysteem?: string | null;
  /**
   * OLO-verzoeknummer
   * Het nummer van het OLO-verzoek.
   */
  oloVerzoeknummer?: string | null;
  /**
   * Doel van de samenwerking
   * Het doel van de samenwerking.
   */
  samenwerkDoel?: string | null;
  /**
   * Type van het verzoek
   * Het type van het verzoek.
   */
  typeVerzoek?:
    | "Aanvraag vergunning"
    | "Melding"
    | "Informatie"
    | "Informatie ongewoon voorval"
    | "Aanvraag maatwerkvoorschrift"
    | "Melding gelijkwaardige maatregel"
    | "Aanvraag toestemming gelijkwaardige maatregel"
    | null;
  /**
   * Verzoeknummer
   * Verzoeknummer van de samenwerking.
   */
  verzoeknummer?: string | null;
  /**
   * Aangemaakt door
   * Het nummer van de organisatie die de samenwerking heeft aangemaakt.
   */
  aangemaaktDoor?: string | null;
  /**
   * Aangemaakt door naam
   * De naam van de organisatie die de samenwerking heeft aangemaakt.
   */
  aangemaaktDoorNaam?: string | null;
  /**
   * Status
   * De status van de samenwerking.
   */
  status?: string | null;
}

/**
 * SubActiviteit
 * Een sub-activiteit van een activiteit.
 */
export interface SubActiviteit {
  /**
   * Id
   * De functioneleStructuurReferentie van de subactiviteit.
   */
  id: string;
  /**
   * Urn
   * De URN (imow-id) van de subactiviteit.
   */
  urn: string;
  /**
   * Naam
   * De naam van de subactiviteit.
   */
  naam: string;
}

/** SyncNowOut */
export interface SyncNowOut {
  /** Processed */
  processed: number;
}

/** SyncStatusOut */
export interface SyncStatusOut {
  /** Sync Enabled */
  sync_enabled: boolean;
}

/** SyncStatusUpdate */
export interface SyncStatusUpdate {
  /** Sync Enabled */
  sync_enabled: boolean;
}

/** TypeConfigField */
export interface TypeConfigField {
  /** Key */
  key: string;
  /** Label */
  label: string;
  /** Field Type */
  field_type: string;
}

/** UpdateActieverzoek */
export interface UpdateActieverzoek {
  /** Melding */
  melding?: string | null;
  /** Omschrijving */
  omschrijving?: string | null;
  /** Productid */
  productId?: string | null;
  /** Status */
  status?: string | null;
  /** Titel */
  titel?: string | null;
}

/** UpdateActieverzoekDocumenten */
export interface UpdateActieverzoekDocumenten {
  /** Documenten */
  documenten: string[];
}

/** UpdatePrivilegeDeelnemer */
export interface UpdatePrivilegeDeelnemer {
  /**
   * Privilege
   * Nieuw toe te kennen privilege voor de deelnemer.
   */
  privilege: string;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
  /** Input */
  input?: any;
  /** Context */
  ctx?: object;
}

/**
 * Verzoek
 * Een verzoek uit het DSO verzoekenoverzicht.
 */
export interface Verzoek {
  /**
   * Id
   * Unieke identifier (gelijk aan verzoeknummer, react-admin compatibiliteit).
   * @example "2025090100015"
   */
  id: string;
  /**
   * Verzoeknummer
   * Het verzoeknummer van het ingediende verzoek.
   * @example "2025090100015"
   */
  verzoeknummer: string;
  /**
   * Volgnummer
   * Het volgnummer van het verzoek.
   * @example "000"
   */
  volgnummer: string;
  /**
   * Verzoektype
   * Het type verzoek (Concept, Definitief, Idee, SDGverzoek).
   * @example "Definitief"
   */
  verzoekType: string;
  /**
   * Doelverzoek
   * Het doel van het verzoek (Indienen, Aanvullen, Intrekken).
   * @example "Indienen"
   */
  doelVerzoek: string;
  /**
   * Verzoeknaam
   * De naam van het verzoek.
   * @example "Test 01 09 2025"
   */
  verzoekNaam?: string | null;
  /**
   * Datumingediend
   * De datum en tijd waarop het verzoek is ingediend (ISO 8601).
   * @example "2025-09-01T10:42:32.28858+02:00"
   */
  datumIngediend: string;
  /** Het bevoegd gezag voor dit verzoek. */
  bevoegdGezag?: BevoegdGezagInfo | null;
  /** De behandeldienst voor dit verzoek, indien van toepassing. */
  behandeldienst?: BevoegdGezagInfo | null;
}

/**
 * VerzoekDetail
 * Gedetailleerde informatie over een ingediend verzoek (via zoek-endpoint).
 */
export interface VerzoekDetail {
  /**
   * Id
   * Unieke identifier (gelijk aan verzoeknummer).
   * @example "2025090100015"
   */
  id: string;
  /**
   * Verzoeknummer
   * Het verzoeknummer.
   * @example "2025090100015"
   */
  verzoeknummer: string;
  /**
   * Volgnummer
   * Het volgnummer.
   * @example "001"
   */
  volgnummer: string;
  /**
   * Verzoektype
   * Het type verzoek (Concept, Definitief, Idee, SDGverzoek).
   * @example "Definitief"
   */
  verzoekType: string;
  /**
   * Doelverzoek
   * Het doel van het verzoek (Indienen, Aanvullen, Intrekken).
   * @example "Indienen"
   */
  doelVerzoek: string;
  /**
   * Plichttype
   * Het plichttype (Aanvraag vergunning, Melding, Informatie, etc.).
   * @example "Melding"
   */
  plichtType?: string | null;
  /**
   * Datumingediend
   * De datum en tijd waarop het verzoek is ingediend (ISO 8601).
   * @example "2025-09-01T10:42:32.28858+02:00"
   */
  datumIngediend: string;
  /**
   * Locatie
   * De projectlocatie als GeoJSON geometrie (ETRS89).
   * @example {"geometrie":{"coordinates":[4.48549,52.07752],"type":"Point"}}
   */
  locatie?: Record<string, any> | null;
  /**
   * Activiteit
   * Activiteiten waarvoor het verzoek is ingediend.
   */
  activiteit?: Activiteit[] | null;
  /** Het bevoegd gezag. */
  bevoegdGezag?: BevoegdGezagInfo | null;
  /** De behandeldienst. */
  behandeldienst?: BevoegdGezagInfo | null;
}

/** ZaakDocument */
export interface ZaakDocument {
  /**
   * Id
   * De unieke identifier van het document.
   */
  id: string;
  /**
   * Document Number
   * Het documentnummer.
   */
  document_number?: number | null;
  /**
   * Name
   * De bestandsnaam van het document.
   */
  name?: string | null;
  /**
   * Mimetype
   * Het MIME-type van het document.
   */
  mimetype?: string | null;
  /**
   * Filesize
   * De bestandsgrootte in bytes.
   */
  filesize?: number | null;
  /**
   * Description
   * Een beschrijving van het document.
   */
  description?: string | null;
  /**
   * Created By
   * Naam van de aanmaker.
   */
  created_by?: string | null;
  /**
   * Last Modified
   * Laatst gewijzigd datum/tijd.
   */
  last_modified?: string | null;
  /**
   * Bron
   * Bronsysteem van het document: 'zaken' of 'dso'.
   */
  bron: string;
  /**
   * Synced
   * Of het document in beide systemen voorkomt.
   * @default false
   */
  synced?: boolean;
  /**
   * Dso Document Id
   * Het DSO document-ID (indien synced).
   */
  dso_document_id?: string | null;
}

/** Organisatie */
export interface AppApiSamenwerkingenDeelnemersSchemasOrganisatie {
  /**
   * Id
   * De identificatie van de organisatie.
   */
  id: string;
  /**
   * Naam
   * De naam van de organisatie.
   */
  naam: string;
}

/** Organisatie */
export interface AppApiSamenwerkingenOrganisatiesSchemasOrganisatie {
  /**
   * Id
   * De identifier van de organisatie.
   */
  id: string;
  /**
   * Naam
   * De naam van de organisatie.
   */
  naam: string;
  /**
   * Laatstgezien
   * De laatste keer dat deze organisatie samenwerkingen heeft opgehaald.
   */
  laatstGezien?: string | null;
}
